module.exports = __webpack_public_path__ + "img/content2.52423c38.png";